import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'searchfilter'
})
export class SearchFilterPipe implements PipeTransform {
    constructor() {}
    transform(items: any[], keys: string, searchText: string, url: any): any[] {
        if (!items) {
            return [];
        }
        if (!searchText) {
            return items;
        }
        searchText = searchText.toLowerCase();
        // return items.filter( it => {
        //       return it.includes(searchText);
        //     });

        return items.filter(item => keys.split(',').some(key => item.hasOwnProperty(key) && new RegExp(searchText, 'gi').test(item[key])));
        //  return res.length ? res : [-1];
    }
}
